import React, { FC } from 'react';
import { Container, Grid, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { TruckItem } from 'templates/services';
import { TruckItemProps } from 'templates/services/TruckItem';
import { SpacingLayout } from 'components/atoms';

interface TruckListSectionProps {
  title: string;
  subTitle: string;
  truckList: Array<TruckItemProps>;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundColor: theme.palette.secondary.main,
  },
  title: {
    textTransform: 'uppercase',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      fontSize: 32,
    },
  },
  subTitle: {
    textAlign: 'center',
    maxWidth: 340,
    margin: 'auto',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      fontSize: 18,
    },
  },
  hrLine: {
    margin: theme.spacing(4, 'auto'),
    maxWidth: 810,
    borderColor: theme.palette.primary.main,
    borderBottom: 0,
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(4, 'auto', 8),
    },
  },
  gridItem: {
    [theme.breakpoints.up('md')]: {
      '&:not(:nth-last-child(-n+2))': {
        marginBottom: theme.spacing(2),
      },
    },
  },
}));

const TruckListSection: FC<TruckListSectionProps> = ({ title, subTitle, truckList }) => {
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <SpacingLayout className={classes.wrapper}>
      <Container maxWidth={false} fixed>
        <Typography
          className={classes.title}
          variant="h2"
          component="h2"
          gutterBottom
          color={'textPrimary'}
          data-aos="fade-up"
          data-aos-delay={200}
        >
          <span>{title}</span>
        </Typography>
        <Typography data-aos="fade-up" data-aos-delay={300} className={classes.subTitle} component="h3" color={'textPrimary'}>
          {subTitle}
        </Typography>
        {!!truckList.length && (
          <>
            <hr className={classes.hrLine} data-aos="fade-up" data-aos-delay={400} />
            <Grid container spacing={isSmallUp ? 6 : 4}>
              {truckList.map((item, idx) => (
                <Grid item xs={6} key={idx} className={classes.gridItem} data-aos="fade-up" data-aos-delay={(idx + 4) * 100}>
                  <TruckItem text={item.text} title={item.title} image={item.image} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Container>
    </SpacingLayout>
  );
};

export default TruckListSection;
